<template>
  <div class="toast" v-show="show" v-html="msg">
  </div>
</template>

<script>
import { getGlobalEvent } from '../../lib/eventEmitter';
const eventEmitter = getGlobalEvent()

export default {
  data() {
    return {
      show: false,
      msg: ''
    }
  },
  methods: {
    close() {
      this.msg = ''
      this.show = false
    }
  },
  mounted() {
    eventEmitter.on('toast', data => {
      this.show = true
      this.msg = typeof data == 'object' ? data.msg : data
      setTimeout(() => {
        this.close()
      }, data.time || 2000)
    })
  },
}
</script>

<style lang="scss" scoped>
  .toast {
    position: fixed;
    z-index: 999999;
    left: 50%;
    top: 50%;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    border-radius: 10px;
    padding: 10px 20px;
    font-size: 18px;
    transform: translate(-50%, -50%);
  }
</style>


// WEBPACK FOOTER //
// src/components/Toast/Toast.vue